import { Form , Input , Button , Select, message, Checkbox } from "antd";
import React, { useEffect, useState } from "react";
import MapComponent from "../components/standard-stops/map-component/map.component";
import '../styles/create-standard-stops.style.scss';
import { createAddressLocation, getStandardStops, updateAddressLocation } from "../actions/address.actions";
import { useDispatch, useSelector } from "react-redux";
import { tripCreateReducerSelector } from "../selector/trip-create.selector";
import { isValid, isValidArray, getArrayfromString } from "../utils/utilities";
import {fetchMaterCitiesAction} from './../actions/trip-create.actions';
import { getLatLngofAddress } from './../actions/admin.action';
import { useLocation, useHistory } from "react-router-dom";
import { loadingAction } from "../actions/loading-actions";

const { Option } = Select;

const DrawLine =()=>{
    return(
        <div className="create-standard-stops-underline">

        </div>
    )
}

export const CreateStandardStopsPage = (props) => {

    const {
        fromModal,
        selectedCity,
        onSuccessRefresh=()=>{},
        operatorCode=null,
        onFailureRefresh=()=>{},
        isAddressBook=false,
        formDetailsFromprops=null,
        cancelModal=()=>{}
    } = props;

    const [form] = Form.useForm();

    const tripCreateReducer = useSelector(tripCreateReducerSelector);
    const [disableOk, setDisableOk] = useState(true);
    const [latLng, setLatLng] = useState(null);
    const [enableLocationPick,setEnableLocationPick] = useState(false);
    const [formDetails,setFormDetails] = useState(null);
    const [disAbleSetMapLocation,setDisableSetMapLocation] = useState(true);
    const [center,setCenter] = useState({lat:13.0694,lng:80.1948});
    const [sameDetailsForDrop,setSameDetailsForDrop] = useState(true);
    const [boardinglatLng,setBoardingLatlng] = useState({lat:null,lng:null});
    const [dropLatlng,setLatLngDrop] = useState({lat:null,lng:null});
    const [mapaddress,setMapAddress] = useState(null);

    const reSetLatLng=(lat,lng,isBoarding,isDrop)=>{
        let data ={latitude:lat,longitude:lng};        
        setLatLng({...data});
        if(isBoarding){
            setBoardingLatlng({lat,lng});
        }
        if(isDrop){
            setLatLngDrop({lat,lng});
        }
    }

    const dispatch = useDispatch();

    useEffect(()=>{
        dispatch(fetchMaterCitiesAction());
    },[]);

    const location = useLocation();
    const history = useHistory();

    const setLoading =(bool)=>{
        dispatch(loadingAction(bool));
    }

    const handleCancel = () => {
        form.resetFields();
        reSetLatLng(null, null, true, true);
        if (fromModal) {
            // Rendered inside a modal -> let the host close it.
            cancelModal();
        } else {
            // Rendered as a standalone page -> go back to the previous screen.
            history.goBack();
        }
    }

    useEffect(() => {
       if(isValidArray(location.state)&&isValidArray(location.state.formdetails)){
        setFormDetails(location.state.formdetails);
        setCenter({lat:location.state.formdetails.latitude,lng:location.state.formdetails.longitude}); 
       }else if(isValidArray(formDetailsFromprops)){
        setFormDetails(formDetailsFromprops);
        setCenter({lat:formDetailsFromprops.latitude,lng:formDetailsFromprops.longitude}); 
       }else{
        setFormDetails(null);
       }
    }, [location,formDetailsFromprops]);

    useEffect(()=>{
        if(isValidArray(formDetails)){
            if(isValid(formDetails.drop_address)){
                setSameDetailsForDrop(false);
            }else{
                setSameDetailsForDrop(true);
            }
            form.setFieldsValue({
                stopname:formDetails.name,
                address:formDetails.address,
                landmark:formDetails.landmark,
                city:formDetails.city,
                phoneNumber:formDetails.phone_number,
                landlineNumber:formDetails.landline_number,
                phoneNumber3:formDetails.phone_number3,
                drop_landmark:formDetails.drop_landmark,
                drop_address:formDetails.drop_address,
            });
            reSetLatLng(formDetails.latitude,formDetails.longitude,true);
            if(isValid(formDetails.drop_latitude)&&isValid(formDetails.drop_longitude)){
                reSetLatLng(formDetails.drop_latitude,formDetails.drop_longitude,false,true);
            }
            setDisableSetMapLocation(false);
        }else{
            form.resetFields();
            reSetLatLng(null,null,true,true);
            if(isAddressBook){
                // New address -> default the phone numbers from the global travels phone number
                const phoneNumbers = getArrayfromString(global.travelsPhoneNumber);
                form.setFieldsValue({
                    phoneNumber:phoneNumbers[0] || null,
                    landlineNumber:phoneNumbers[1] || null,
                    phoneNumber3:phoneNumbers[2] || null,
                });
            }
        }

    },[formDetails]);


    let { masterCities } = tripCreateReducer;

    const onSuccess=(savedRecord)=>{
        setLoading(false);
        form.resetFields();
        reSetLatLng(null,null,true,true);
        // Only the standalone standard-stops page consumes the global standardAddressStops
        // state. In modal usages (address book / trip-create) the host refreshes its own data
        // via onSuccessRefresh, so this global fetch would be an unnecessary getStandardAddresses call.
        if(!fromModal){
            dispatch(getStandardStops());
        }
        onSuccessRefresh(isValid(savedRecord)?savedRecord.id:null,savedRecord);
    }

    const onFailure=(errMsg)=>{
        message.error(errMsg);
        setLoading(false);
        onFailureRefresh(errMsg)
    }

    const createAddress=()=>{
        form.validateFields()
        .then(values => {
            let {
                stopname,
                address,
                city,
                landmark,
                phoneNumber,
                landlineNumber,
                phoneNumber3,
                drop_landmark,
                drop_address
            } = values
            if(!isAddressBook){
                phoneNumber=null
            }
            let formatedData = {
                name:stopname,
                latitude:boardinglatLng.lat, 
                longitude:boardinglatLng.lng, 
                landmark:landmark, 
                address:address, 
                phone_number:phoneNumber, 
                landline_number:landlineNumber, 
                phone_number3:phoneNumber3, 
                city:city, 
                is_office:(isValid(formDetails)&&isValid(formDetails.id)&&formDetails.is_office)?1:0, 
                agent_user_name:null, 
                precedence_number:null, 
                is_active:1, 
                operator_code:operatorCode,
                drop_address:drop_address,
                drop_landmark:drop_landmark,
                drop_latitude:sameDetailsForDrop ? boardinglatLng.lat : dropLatlng.lat,
                drop_longitude:sameDetailsForDrop ? boardinglatLng.lng : dropLatlng.lng
            };
            setLoading(true);
            const handleSuccess=(returnedId)=>{
                let savedRecord = {
                    ...formatedData,
                    id:(isValid(formDetails)&&isValid(formDetails.id))?formDetails.id:returnedId
                };
                onSuccess(savedRecord);
            };
            if(isValid(formDetails)&&isValid(formDetails.id)){
                formatedData.id = formDetails.id;
                updateAddressLocation(formatedData,handleSuccess,onFailure);
            }else{
                createAddressLocation(formatedData,handleSuccess,onFailure);
            }
        });
    }

    let buttonName = isValidArray(formDetails)&&isValid(formDetails.id)?"Update":"Create";

    let customClassName ='';

    if(enableLocationPick){
        customClassName = 'disabledDiv';
      }else{
        customClassName = '';
      }

      useEffect(()=>{
        if(isValid(selectedCity)){
            form.setFieldsValue({
                city:selectedCity
            })
        }
      },[selectedCity])
    return (
        <div className={fromModal?"":"create-standard-stops-root"}>
            <div className={`create-standard-stops-inner-div`}>
                <div className={customClassName}>
                    <h3>
                        {buttonName} {isAddressBook?"Address":"Standard Stop"}
                    </h3>     
                    <DrawLine />
                </div>
                <div className={`create-standard-stops-form`}>
                    <div className={`create-form-div ${customClassName}`}>
                            <Form
                                initialValues={{
                                    city:selectedCity
                                }}
                                name="basic"
                                form={form}
                            >
                                <div className="create-form-inner-div">
                                    <Form.Item    
                                    name="stopname"
                                    rules={[{ required: true ,  message:"Please input stop name"}]}
                                    label="">
                                        <Input placeholder="Stop Name"/>
                                    </Form.Item>
                                    <Form.Item    
                                    name="city"
                                    rules={[{ required: true ,  message:"Please input city"}]}
                                    label="">
                                        <Select
                                        disabled={isValid(selectedCity)?true:false}
                                        showSearch
                                        size="large"
                                        style= {{backgroundColor: 'white',width: 200}}
                                        placeholder="Select a city"
                                        optionFilterProp="children"
                                        >
                                            {masterCities.map(item => (
                                                <Option key = {item.id} value= {item.city_name} data={item}>{item.city_name}{isValid(item.alias_city_name)?"("+item.alias_city_name+")":null}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    {isAddressBook?
                                        <Form.Item
                                        name="phoneNumber"
                                        rules={[{ required: true ,  message:"Please input phone number"}]}
                                        label=""
                                        >
                                            <Input placeholder="Phone Number"/>
                                        </Form.Item>
                                        :null
                                    }
                                    {isAddressBook?
                                    <Form.Item
                                    name="landlineNumber"
                                    label=""
                                    >
                                        <Input placeholder="Phone Number 2"/>
                                    </Form.Item>
                                    :null
                                    }
                                    {isAddressBook?
                                    <Form.Item
                                    name="phoneNumber3"
                                    label=""
                                    >
                                        <Input placeholder="Phone Number 3"/>
                                    </Form.Item>
                                    :null
                                    }
                                    <Checkbox 
                                    checked={sameDetailsForDrop}
                                    onChange={(e)=>{
                                        setSameDetailsForDrop(e.target.checked);
                                    }}>Same Details for Drop</Checkbox>
                                    <div className="boarding-point-block">
                                        {!sameDetailsForDrop&&
                                            <h4 className="block-title">Boarding Point</h4>
                                        }
                                        <Form.Item    
                                        name="landmark"
                                        rules={[{ required: true ,  message:"Please input landmark"}]}
                                        label="">
                                            <Input placeholder="Landmark"/>
                                        </Form.Item>
                                        <Form.Item name = {'address'} label = "" rules={[{ required: true, message: "" }]}>
                                            <Input.TextArea 
                                                placeholder='Address'
                                                onChange={(e)=>{
                                                    if(e.target.value.length >= 4){
                                                        setDisableOk(false);
                                                    }else{
                                                        setDisableOk(true);
                                                    }
                                                }}
                                            />
                                        </Form.Item>
                                        <div className='marginBottom fetch-latlng-ok-button'>
                                            <Button 
                                                className='ok-button-address'
                                                size='small'
                                                disabled={disableOk}
                                                onClick={()=>{
                                                    let{
                                                        address
                                                    } = form.getFieldsValue();
                                                    setDisableOk(true);
                                                    setDisableSetMapLocation(false);
                                                    getLatLngofAddress(address,(lat,lng)=>{
                                                        reSetLatLng(lat,lng,true);
                                                        setCenter({lat,lng}); 
                                                    },(lat,lng)=>{
                                                        console.log("Failed",{lat,lng});
                                                    });
                                                }}
                                            >Add to map</Button>
                                        </div>
                                        <Form.Item>
                                            <Button className='setLocationOnMapButton'
                                            disabled={disAbleSetMapLocation}
                                            onClick={()=>{
                                                setMapAddress("pickup")
                                                setEnableLocationPick(true);
                                            }}
                                            >Set Location on Map</Button>
                                        </Form.Item>
                                    </div>
                                    {!sameDetailsForDrop&&
                                    <div className="drop-point-block">
                                        <h4 className="block-title">Drop Point</h4>
                                        <Form.Item name = {'drop_landmark'} label = "" rules={[{ required: true, message: "" }]}>
                                            <Input placeholder="Landmark (Drop)"/>
                                        </Form.Item>
                                        <Form.Item name = {'drop_address'} label = "" rules={[{ required: true, message: "" }]}>
                                            <Input.TextArea placeholder="Address (Drop)" 
                                            onChange={(e)=>{
                                                if(e.target.value.length >= 4){
                                                    setDisableOk(false);
                                                }else{
                                                    setDisableOk(true);
                                                }
                                            }}
                                            />
                                        </Form.Item>
                                        <div className='marginBottom fetch-latlng-ok-button'>
                                            <Button 
                                                className='ok-button-address'
                                                size='small'
                                                disabled={disableOk}
                                                onClick={()=>{
                                                    let{
                                                        drop_address
                                                    } = form.getFieldsValue();
                                                    setDisableOk(true);
                                                    setDisableSetMapLocation(false);
                                                    getLatLngofAddress(drop_address,(lat,lng)=>{
                                                        reSetLatLng(lat,lng,false,true);
                                                        setCenter({lat,lng}); 
                                                    },(lat,lng)=>{
                                                        console.log("Failed",{lat,lng});
                                                    });
                                                }}
                                            >Add to map</Button>
                                        </div>
                                        <Form.Item>
                                            <Button className='setLocationOnMapButton'
                                            disabled={disAbleSetMapLocation}
                                            onClick={()=>{
                                                setMapAddress("drop")
                                                setEnableLocationPick(true);
                                            }}
                                            >Set Location on Map</Button>
                                        </Form.Item>
                                    </div>
                                    }
                                </div>
                                <div className="submit-buttons">
                                    <Button  className="cancel-button" onClick={handleCancel}>
                                        Cancel
                                    </Button>
                                    <Button onClick={createAddress}>
                                        {buttonName}
                                    </Button>
                                </div>
                            </Form>
                    </div>
                    <div>
                        <MapComponent 
                            boardingLatLng={boardinglatLng}
                            dropLatLng={dropLatlng}
                            sameDetailsForDrop={sameDetailsForDrop}
                            activeMarkerType={mapaddress}
                            onMarkerDragEnd={(lat,lng,markerType)=>{
                                if(markerType === "pickup" || mapaddress=="pickup"){
                                    reSetLatLng(lat,lng,true,sameDetailsForDrop);
                                }else if(markerType === "drop" || mapaddress=="drop"){
                                    reSetLatLng(lat,lng,sameDetailsForDrop,true);
                                }
                            }}
                            enableLocationPick={enableLocationPick}
                            setEnableLocationPick={(bool)=>{
                                if(bool==false){
                                    setMapAddress(null);
                                }
                                setEnableLocationPick(bool);
                            }}
                            onCancel={(markerType,lat,lng)=>{
                                if(markerType === "pickup"){
                                    reSetLatLng(lat,lng,true,sameDetailsForDrop);
                                }else if(markerType === "drop"){
                                    reSetLatLng(lat,lng,sameDetailsForDrop,true);
                                }
                            }}
                            center={center}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}